import React from "react";
import { BCMSRecord, BCMSDefaultModel, Workflow, useBCMSContext, useParams } from "bcms-react";
import Classes, { ACHTemplate, UserAccount } from "model";
import DenyUsersPage from "components/pages/DenyUsersPage";

// Steps of the workflow
const steps = [ DenyUsersPage ];

/**
 * @function DenyUsersWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the feature "Deny ACH Template Access - Mass Update".
 */
export default function DenyUsersWorkflow(props) {
    const controller = useBCMSContext();
    const { stepID } = useParams();
    // Get the inital state of the workflow
    const value = getDefaultWorkflowData(controller);
    // Return the workflow component
    return <Workflow value={ value } steps={ steps } step={ stepID } />;
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefaultWorkflowData = controller => {
    BCMSRecord.globalControllerFor(Classes, controller);

    // Return the default workflow state.
    return {
        data: {
            // None for now until more pages are in the workflow.
        },
        ui: {
            // None for now until more pages are in the workflow.
        }
    };
};